import { toUrlParams } from './toUrlParams';
import { REDIRECT_PATH } from '../../Core.constants';

export const getRatesUrl = (params = {}) => {
  const {
    applyClubDiscount,
    chainSelectorValue,
    checkin,
    clientCodeStrictSearch,
    contactCenter,
    currency,
    device: deviceType,
    env,
    fingerprint,
    hsri,
    idchain,
    idtokenprovider,
    language,
    nights,
    notification,
    parties,
    promocode,
    rooms,
    utm_source,
    variant,
  } = params;
  return `${process.env.SERVICE_BOOKING}/${REDIRECT_PATH}${toUrlParams({
    applyClubDiscount,
    cart: rooms
      ?.split(',')
      ?.flatMap((room) => {
        const [id, amount = 1] = room.replace(/\|/g, '--').split(':');
        return Array.from({ length: Number(amount) }, () => id);
      })
      ?.join(','),
    chainSelectorValue,
    checkin,
    clientCode: promocode,
    clientCodeStrictSearch,
    contactCenter,
    currency,
    deviceType,
    env,
    fingerprint,
    hsri,
    idchain,
    idtokenprovider,
    lang: language,
    nights,
    notification,
    parties,
    utm_source,
    variant,
  })}`;
};
